const getAddressFromLatLng = (
    latLng: google.maps.LatLngLiteral
): Promise<string> => {
    return new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: latLng }, (results, status) => {
            if (status === "OK" && results) {
                console.log("geocode results: ", results);
                if (results.length >= 3) {
                    resolve(results[2].formatted_address);
                } else if (results.length >= 2) {
                    resolve(results[1].formatted_address);
                } else {
                    resolve(results[0].formatted_address);
                }
                // resolve(results[0].formatted_address);
            } else {
                reject(
                    new Error(
                        "Geocode was not successful for the following reason: " +
                            status
                    )
                );
            }
        });
    });
};

export default getAddressFromLatLng;
